import React from "react";

import Button from "../common/Button";

const CalculateRoiButton: React.FunctionComponent = () => (
  <Button
    tag="a"
    href="/roi-calculator/"
    color="white"
    className="button-wide-mobile"
  >
    Calculate ROI
  </Button>
);

export default CalculateRoiButton;
